<template>
  <div class="mt-3">
    <b-col
      cols="12"
      class="h5 text-azul-medio font-weight-normal px-0 text-center text-lg-left gilmer"
    >
      INTERNADO
    </b-col>
    <div class="rounded text-white px-3 pt-3 pb-0 bg-morado-oscuro mb-2">
      <b-row class="pb-0 mb-0 text-white">
        <b-col
          v-if="infoInstitucionalInternado"
          cols="12"
          class="mb-3 text-justify"
        >
          El establecimiento cuenta con servicio de internado para el año
          {{ añoSiguiente }}. Quienes requieran el servicio deberán comunicarse
          directamente con el establecimiento antes del periodo de matrícula
          para obtener información sobre requisitos, documentación necesaria,
          disponibilidad de camas y plazos de tramitación.
        </b-col>
        <b-col v-else cols="12" class="mb-3 text-justify">
          Quienes requieran el servicio de internado deberán comunicarse
          directamente con el establecimiento antes del periodo de matrícula
          para obtener información sobre requisitos, documentación necesaria,
          disponibilidad de camas y plazos de tramitación
        </b-col>
        <b-col
          cols="12"
          class="gilmer text-white font-weight-bold mb-3 text-justify bg-morado-oscuro"
        >
          IMPORTANTE: La solicitud de internado es posterior a la postulación,
          recuerde agregar al establecimiento en sus preferencias.
        </b-col>
        <b-col cols="12" class="d-print-none text-center"> </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faDownload);
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    infoInstitucionalInternado: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      añoSiguiente: localStorage.getItem("anioSiguiente") || "default value"
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/izquierda/Internado.vue